import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';

import allAnimalsImage from '../assets/login/allAnimals.svg';
import { AppContext } from '../AppContext';

axios.defaults.withCredentials = true;

function LoginPage() {
    const navigate = useNavigate();
    const { userId, checkSession } = useContext(AppContext);
    
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMess, setErrorMess] = useState('');
    const [isMdOrLess, setIsMdOrLess] = useState(window.innerWidth <= 768);
    
    useEffect(() => {
        if (userId) {
            navigate('/home');
        }
    }, [userId, navigate]);
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    const handleResize = () => {
        setIsMdOrLess(window.innerWidth < 768);
    };
    
    const handleUsernameChange = (e) => setUsername(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
    
    const handleLogin = async (event) => {
        event.preventDefault();
        setShowError(false);
        
        if (!username || !password) {
            setErrorMess("Per favore inserisci username e password");
            setShowError(true);
            return;
        }
        
        const axiosConfig = {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        };
        
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/patientLogin`, {
                username,
                password
            }, axiosConfig);
            
            setLoading(false);
            
            if (response.data.success) {
                await checkSession();
            } else {
                setErrorMess(response.data.errorMess || "Credenziali non valide");
                setShowError(true);
            }
        } catch (error) {
            setErrorMess("Errore di rete o del server.");
            setLoading(false);
            setShowError(true);
        }
    };
    
    return (
        <div className={'container-fluid h-100 center flex-grow-1 ' + (isMdOrLess ? 'smallLoginBackground' : 'loginBackground')}>
            <div className='row w-100'>
                <div className='d-none d-md-block col-md-6 col-lg-6 col-xl-6 center'>
                    <img src={allAnimalsImage} className='allAnimals' alt="All Animals" />
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 center loginFormPart'>
                    <div className='loginForm center col'>
                        <h2 className='row center welcomeLoginText w-100'>Benvenuto!</h2>
                        <label className='loginLabels row w-100 loginFormText'> Username </label>
                        <input className="row w-100 loginTextArea" onChange={handleUsernameChange} />
                        <label className='loginLabels row w-100 loginFormText'> Password </label>
                        <input className="w-100 row loginTextArea" type="password" onChange={handlePasswordChange} />
                        
                        <button className="center row mt-4 loginButton" type="submit" disabled={isLoading} onClick={handleLogin}>
                            {!isLoading ? 'Login' : <Spinner animation="border" variant="light" />}
                        </button>
                        {showError && <p className='loginLabels errorMessColor'>{errorMess}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;